import { UserRoles } from "~/types/models/user.interface";

export default defineNuxtRouteMiddleware(async () => {
  const store = useUserStore();

  if (!store.user || store.user.role !== UserRoles.ADMIN) {
    return navigateTo("/login");
  }
});
